import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const TeamsIcon = ({ fill = 'gcBlue', size = 'medium' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox={'0 0 32 32'}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <path
                    className={fillStyles}
                    d="M22.6505984,13.15 L22.6505984,8.375 L24.7418512,4.649 L26.9247363,10.739 C27.0133142,10.985 26.9980421,11.249 26.8809564,11.481 C26.7648888,11.713 26.5612615,11.886 26.3097817,11.967 L22.6505984,13.15 Z M5.3504197,13.15 L0.963268673,11.733 L1.69021827,11.967 C1.43873851,11.886 1.23511117,11.713 1.11904359,11.481 C1.00195787,11.249 0.987703954,10.985 1.07526371,10.74 L0.843128543,11.385 L1.07526371,10.74 L3.25814879,4.649 L5.3504197,8.375 L5.3504197,13.15 Z M27.8858573,10.407 L25.3232073,3.258 C25.202049,2.98 25.0055486,2.735 24.7520326,2.56 C24.658364,2.494 24.5555322,2.435 24.4445553,2.392 L19.2021694,0.125 C18.9873426,0.04 18.7490986,0 18.5057639,0 C17.9468069,0 17.366469,0.213 16.9968854,0.588 L14.0005091,3.646 L11.0031146,0.588 C10.633531,0.213 10.0542112,0 9.49423605,0 C9.25191952,0 9.01163926,0.04 8.79783055,0.125 L3.5554447,2.392 C3.44548594,2.435 3.341636,2.494 3.24694928,2.56 C2.99445138,2.735 2.79896914,2.98 2.67781087,3.258 L0.114142669,10.407 C-0.257477225,11.444 0.308606778,12.574 1.37255963,12.918 L5.3504197,14.203 L5.3504197,22 C5.3504197,23.1 6.26470645,24 7.38669309,24 L20.614325,24 C21.7352935,24 22.6505984,23.1 22.6505984,22 L22.6505984,14.203 L26.6274404,12.918 C27.6913932,12.574 28.2574772,11.444 27.8858573,10.407 L27.8858573,10.407 Z"
                    id="teams-path"
                ></path>
            </defs>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-940.000000, -169.000000)">
                    <g transform="translate(34.000000, 162.000000)">
                        <g transform="translate(906.000000, 6.000000)">
                            <g transform="translate(0.000000, 1.000000)" id="teams">
                                <mask id="mask-2" fill="white">
                                    <use xlinkHref="#teams-path"></use>
                                </mask>
                                <use id="Mask" fill="#059BFC" xlinkHref="#teams-path"></use>
                                <g id="Blue" mask="url(#mask-2)" fill="#0070C8">
                                    <rect id="Rectangle-7" x="0" y="0" width="28" height="24"></rect>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};
